import { ChangeDetectorRef, Component,Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from '../../../core/model/modal.config-model';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import moment from 'moment';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubmitQuoteModel } from '../../../core/model/submit-quote-model';
import { CustomProductsService } from '../../../modules/custom-landing/custom-products/custom-products.service';
import { ToastrService } from 'ngx-toastr';
import { TranslationService, I18nModule } from '@spartacus/core';
import {NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter, DateRangePickerI18nService } from 'src/app/shared/services/date-range-picker-i18n.service';
import { TwoDigitDecimaNumberDirective, CopyDirective, allowPositiveAndNegativeNumbersDirective } from '../two-digit-decima-number.directive';

@Component({
    selector: 'app-confirm-bid-modal',
    templateUrl: './confirm-bid-modal.component.html',
    styleUrls: ['./confirm-bid-modal.component.scss'],
    providers: [{ provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService }, { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
    imports: [NgIf, FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, allowPositiveAndNegativeNumbersDirective, ReactiveFormsModule, NgbInputDatepicker, NgFor, I18nModule]
})
export class ConfirmBidModalComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @ViewChild('modal') private modalContent: TemplateRef<ConfirmBidModalComponent>;
  submitQuoteModel = new SubmitQuoteModel();
  private modalRef: NgbModalRef;
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    singleCalendar: true,
    minDate: moment().subtract(0, 'day'),
    maxDate: moment().add(1, 'year'),
    validators: Validators.required,
  };
  timeSelected: any;
  timeStart = 0; // start time in hours;
  timeEnd = 24; // end time in hours;
  timeInterval = 10; // interval in min;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  timeArray = [];
  startDate: NgbDate = null;
  endDate: any = null;
  datePipe = new DatePipe('en-US');
  showDateError = false;
  modalReference: any;
  convertedDate: any
  form: UntypedFormGroup;
  closeResult = '';
  productInfo: any;
  closeModal: any;
  disabledBtn: any = false;
  showquantity = false;
  biddingTerms = '';
  quantitySelected: number;
  actualQuantitySelected:number;
  quantityRangeArray = [];
  selectedDate: any;
  dateSelected: any;
  error: string;
  priceAlert: any = true;
  counterOfferError = false;
  counterOfferErrorValue = '';
  originalPrice;
  placebidfirst: string;
  placebidsecond: string;
  placemsg: string;
  minPrice: any;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  confirmTxt: string;
  qtyEmptyErr:boolean=false;
  qtyValidErr:boolean=false;
  minQty:number;
  maxQty:number;
  maxLen:number;
  constructor(private router: Router, private customProductService: CustomProductsService,
              private modalService: NgbModal, private route: ActivatedRoute, private toastService: ToastrService
              // tslint:disable-next-line:align
              , private translation: TranslationService, private cd: ChangeDetectorRef,public formatter: NgbDateParserFormatter,
              calendar: NgbCalendar) {
                this.startDate = calendar.getToday();
  }
  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl()
    });
    this.customProductService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    const momentObj = moment();
    //this.startDate = momentObj.toDate();
    this.dateSelected = momentObj.format('DD/MM/YYYY');
    for (let i = this.timeStart; i <= this.timeEnd; i++) {
      const timeString = ('0' + i).slice(-2);
      const timeStringWith0 = timeString + ':00';
      const halfTimeString = timeString + ':30';
      if (halfTimeString !== '24:30'){
        this.timeArray.push(timeStringWith0);
        this.timeArray.push(halfTimeString);
      }
    }

    this.timeSelected = '17:00';
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.translation.translate('home.toastErrorMessages.placebidfirst').subscribe(res => {
      this.placebidfirst = res;
    });
    this.translation.translate('home.toastErrorMessages.placebidsecond').subscribe(res => {
      this.placebidsecond = res;
    });
    this.translation.translate('home.datePicker.nextMonth').subscribe(res=>{
      this.nextMonth = res;
    })
    this.translation.translate('home.datePicker.preMonth').subscribe(res=>{
      this.preMonth = res;
    })
    this.translation.translate('home.datePicker.selectMonth').subscribe(res=>{
      this.selectMonth = res;
    })
    this.translation.translate('home.datePicker.selectyear').subscribe(res=>{
      this.selectYear = res;
    })
  }
  open(content: any, data: any): any {
    this.quantityRangeArray = [];
    this.productInfo = data;
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.originalPrice = this.productInfo.price;
    this.minPrice =  this.productInfo.minPrice;
    this.quantitySelected = this.productInfo.quantitySelected;
    this.minQty = this.productInfo.minimumQty;
    this.maxQty= this.productInfo.maximumQty;
    this.maxLen=this.maxQty.toString().length+1;

    // if (this.productInfo.maximumQty !== undefined && this.productInfo.minimumQty !== undefined) {
    //   if (this.productInfo.quantitySelected) {
    //     this.quantitySelected = this.productInfo.quantitySelected;
    //   } else {
    //     this.quantitySelected = Number(this.productInfo.minimumQty);
    //   }
    //   const quantityRangeMin = Number(this.productInfo.minimumQty);
    //   const quantityRangeMax = Number(this.productInfo.maximumQty) / quantityRangeMin;
    //   for (let i = 1; i <= quantityRangeMax; i++) {
    //     this.quantityRangeArray.push(quantityRangeMin * i);
    //   }
    // }
    if(this.productInfo.actualQuantitySelected <data.minimumQty)
    {
      this.actualQuantitySelected = this.productInfo.actualQuantitySelected;
      this.showquantity = true;
    }
    this.actualQuantitySelected = this.productInfo.actualQuantitySelected;

    this.modalRef = this.modalService.open(this.modalContent);
    this.modalRef.result.then();
    this.placemsg = this.placebidfirst + " ¥" + this.minPrice + " " + this.placebidsecond
  }
  isValidLetter(k): any {
    return ((k >= 48 && k <= 57 && k !== 0));
  }
  close(): any {
    this.modalRef.close();
  }

  dismiss(): any {
    this.modalRef.dismiss();
  }
  selectTimeFunction(): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
  }
  onRangeSelected(value: IDateRange): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.firstFieldEmittedValue = value;
    //this.startDate = this.firstFieldEmittedValue.start.toDate();
    // this.filterData();
  }

  checkPad(d){
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  onDateSelection(selectedDate){

    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.startDate = selectedDate;
   
  }  
  onReset(event: any): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    if (event !== undefined) {
      this.dateRangePicker.reset(event);
      this.dateRangePicker.toggleCalendarVisibility(false);
    }
    //  this.dateRangePicker.toggleCalendarVisibility(false);
    // event.preventDefault();
    // event.stopPropagation();
    this.showDateError = false;
    this.startDate = null;

  }
  modalid(k): any {
    return k;
  }
  isValid(item: string): any {
    return Object.keys(item).length;
    // return objectKeys(item).length>0?true:false
  }
  isVisible(item: string): any {
    return Object.keys(item).length > 0 ? 'visible' : 'hidden';
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  navigateToQuote(productInfo, quantitySelected,actualQuantitySelected): any {
    let qtyCheck;
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    qtyCheck = this.checkQtyValidation();
    if (this.startDate != null && qtyCheck == false) {
      this.disabledBtn = true;
      this.submitQuoteModel.quoteEntryRequest.basePrice = this.productInfo.priceValue;
      this.submitQuoteModel.quoteEntryRequest.productCode = this.productInfo.code;
      // if(this.productInfo.actualQuantitySelected<this.productInfo.minimumQty){
      //   this.submitQuoteModel.quoteEntryRequest.quantity = this.actualQuantitySelected;
      // }
      
        this.submitQuoteModel.quoteEntryRequest.quantity = this.quantitySelected;
      
      this.submitQuoteModel.remark = this.biddingTerms;
      this.submitQuoteModel.quoteTemplate = {};

      if (this.startDate != null) {
        this.convertedDate = this.startDate.year+'-'+this.checkPad(this.startDate.month)+'-'+this.checkPad(this.startDate.day);
         //this.convertedDate = this.customProductService.convertDateForCounterOffer(this.startDate);
        const dateTime = moment(this.convertedDate + ' ' + this.timeSelected, 'YYYY-MM-DD HH:mm');
        // this.quoteEditModel.validity = `${convertedDate}T${this.timeSelected}:00+0000`;
        this.submitQuoteModel.validity = dateTime.format();
      }
      this.customProductService.createQuote(this.submitQuoteModel).subscribe((res: any) => {
        if (res.status === 'BID_PLACED') {
          this.homeLinkClick(false);
          this.counterOfferError = false;
          this.customProductService.bidPlaced = true;
          this.router.navigate([`/quotes`], { state: res, relativeTo: this.route });
          this.disabledBtn = false;
          this.close();
        }
        else {
          if (res.status){
                this.counterOfferError = true;
                this.counterOfferErrorValue = res.status;
                this.disabledBtn = false;
          }else{
            this.toastService.show(this.error);
            this.disabledBtn = false;
          }
        }
        // // else{
        //   this.toastService.show(this.error);
        //   this.disabledBtn = false;
        //   this.close();
        // // }
      },
        err => {
          this.toastService.show(this.error);
          this.disabledBtn = false;
        }
      );
    }
    else {
      this.showDateError = true;
    }
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    if (k === 46){
    return false;
    }
    return this.isValidLetter(k);
  }
  // tslint:disable-next-line:typedef
  checkDate(event) {
    if (event.charcode) {

    }
  }
  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  // tslint:disable-next-line:typedef
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }

  validateDecimalPointPrice(e): any{
    const t = e.target.value;
    this.productInfo.priceValue = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2)) : t;
    this.cd.detectChanges();
  }


  disableEarlyTime(timeValue): any{
    const currentTime = moment();
    const currentTimeValue = moment(currentTime).format('hh:mm');
    const beginningTime = moment(timeValue, 'hh:mm');
    if (beginningTime.isBefore(currentTimeValue)){
      return true;
    }else{
      return false;
    }
  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      console.log(value);
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  checkQtyValidation(){
    let priceToCheck
    //this.showquantity?priceToCheck = this.actualQuantitySelected:
    priceToCheck=this.quantitySelected;
    
    this.showquantity?priceToCheck = this.actualQuantitySelected:priceToCheck=this.quantitySelected;
    
    if(priceToCheck ===null){
      this.qtyEmptyErr = true;
    }else{
      if(Number(this.minQty)<=Number(priceToCheck) && Number(this.maxQty)>=Number(priceToCheck)){
        //QTY SHOULD BE BETWEEN 2K-50K
        this.qtyValidErr = false;
      }else{
        this.qtyValidErr = true;
      }
      this.qtyEmptyErr = false;
    }
    let flag =this.qtyEmptyErr||this.qtyValidErr;
    return flag;
  }
}
